import { NotificationLevel } from './level';
const DEFAULT_ERROR_HIDE_DELAY = 30000;
const DEFAULT_WARNING_HIDE_DELAY = 30000;
const DEFAULT_SUCCESS_HIDE_DELAY = 5000;
const hideDelaysMap = {
    [NotificationLevel.Error]: DEFAULT_ERROR_HIDE_DELAY,
    [NotificationLevel.Warning]: DEFAULT_WARNING_HIDE_DELAY,
    [NotificationLevel.Success]: DEFAULT_SUCCESS_HIDE_DELAY,
};
export const HIDE_DELAYS_MAP = Object.freeze(hideDelaysMap);
export const HIDE_DELAY_BY_END_CALL = 10000;
